import { render } from "./MyProfilePage.vue?vue&type=template&id=7e4a6308&ts=true"
import script from "./MyProfilePage.vue?vue&type=script&lang=ts"
export * from "./MyProfilePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__